import { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { FLAG_REDIRECT_FROM_DOCUMENTS, getItem, getUserAuth, setDashboardTab } from "../../../utils/LocalStorageUtils";
import { isForeigner } from "../../../utils/StringUtil";
import { getNominationDrawDownDetails, getUserDetails } from "../../apis/apis";
import AuthLayout from "../../components/layout/AuthLayout";
import CustomSnackbar from "../../components/Toast/CustomSnackbar";

function NominationSuccessfull(props) {
    const history = useHistory();
    const [errorData, setErrorData] = useState();
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const handleSnackbarClose = () => {
        setOpenSnackbar(false);
    };
    const [nominationStatus, setNominationStatus] = useState(-1);
    const [fatcaStatus, setFatcaStatus] = useState(false);

    const fetchNominationData = async () => {

        const nominationDetails = await getNominationDrawDownDetails({
            "envelopId": getItem("NOMINATION_ENVELOPE_ID")
        });
        if (nominationDetails.status) {
            const { status } = nominationDetails.data;

            if (status === 1) {

                setNominationStatus(status);

                // else {
                //     history.replace("/success-lp", {"alertTitle": 'Nomination Successfully Signed'});
                // }
            } else {
                // setErrorData('MCA not signed');
                setErrorData("You need to complete the Nomination signing to proceed further with the investments");
                setOpenSnackbar(true);
                setTimeout(() => {
                    history.replace("/user/nomination");
                }, 2000);
            }
        } else {
            setErrorData(nominationDetails.description);
            setOpenSnackbar(true);
            setTimeout(() => {
                history.replace("/user/nomination");
            }, 2000);

        }
    };

    const handleContinue = async () => {
        if (!fatcaStatus && isForeigner()) {
            history.replace("/user/fatca");
        } else {
            setDashboardTab(1);
            history.push("/user/home")
        }
    };

    useEffect(() => {
        setTimeout(() => {
            fetchNominationData();
        }, 2000);
    }, []);

    const fetchUserData = async () => {
        const userDetails = await getUserDetails();
        if (userDetails.status) {
            setNominationStatus(userDetails.data.hasNomination)
            setFatcaStatus(userDetails.data.hasFatca)
        }
    }

    useEffect(() => {
        fetchUserData();
    }, []);

    return (
        <AuthLayout title={nominationStatus === -1 ? '' : 'Nomination Successfully Signed'}>
            {
                nominationStatus === -1
                    ? <div className="d-flex justify-content-center">
                        <div className="loading-spinner"></div>
                    </div>
                    : <>
                        {getUserAuth() && !getItem(FLAG_REDIRECT_FROM_DOCUMENTS) ?
                            <>
                                <div className="col-4">
                                    <div className='d-flex mt-3'>
                                        <button type="button"
                                            onClick={handleContinue}
                                            className="btn btn-primary px-3 py-2">Continue</button>
                                    </div>
                                </div>
                            </>

                            : ""}
                        {getItem(FLAG_REDIRECT_FROM_DOCUMENTS) ?
                            <div className="col-4">
                                <div className='d-flex mt-3'>
                                    <button type="button"
                                        onClick={() => history.push("/user/documents/")}
                                        className="btn btn-primary px-3 py-2">Finish</button>
                                </div>
                            </div> : null
                        }
                    </>
            }
            <CustomSnackbar
                open={openSnackbar}
                severity="error"
                duration={2000}
                text={errorData}
                handleClose={handleSnackbarClose}
            />
        </AuthLayout>
    );
}

export default NominationSuccessfull;
